(() => {
  const groupSelector = '.ProductList,.CarouselWrapper,.Grid,.LGBestsellers__list';
  const fields = [
    ['.ProductCard__ImageWrapper .Ratio', '--lg-card-image-height'],
    ['.ProductCard__Vendor', '--lg-card-vendor-height'],
    ['.ProductCard__Title', '--lg-card-title-height'],
    ['.ProductCard__Rating', '--lg-card-rating-height'],
    ['.ProductCard__Meta', '--lg-card-price-height'],
    ['.ProductCard__ColorSwatch', '--lg-card-swatches-height']
  ];
  const lists = new Map();
  const pending = new Set();
  let frame;
  const schedule = list => {
    pending.add(list);
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = null;
      const updates = [];
      pending.forEach(group => {
        if (!group.isConnected || !group.getBoundingClientRect().width) return;
        const info = [...group.querySelectorAll('.ProductCard')]
          .filter(card => card.closest(groupSelector) === group && card.getBoundingClientRect().width);
        if (!info.length) return;
        fields.forEach(([selector, property]) => {
          const height = Math.max(0, ...info.map(card => {
            const field = card.querySelector(selector);
            if (!field || !field.getClientRects().length) return 0;
            const style = getComputedStyle(field);
            return field.getBoundingClientRect().height + (parseFloat(style.marginTop) || 0) + (parseFloat(style.marginBottom) || 0);
          }));
          updates.push([group, property, Math.ceil(height) + 'px']);
        });
      });
      pending.clear();
      updates.forEach(([group, property, value]) => {
        if (group.style.getPropertyValue(property) !== value) group.style.setProperty(property, value);
      });
    });
  };
  const initialize = () => {
    lists.forEach((state, list) => {
      if (!list.isConnected) {
        state.observer.disconnect();
        lists.delete(list);
      }
    });
    const groups = new Set([...document.querySelectorAll('.ProductCard__Info')].map(info => info.closest(groupSelector)).filter(Boolean));
    groups.forEach(list => {
      if (!lists.has(list)) {
        lists.set(list, { observer: new ResizeObserver(() => schedule(list)), nodes: new Set() });
      }
      const state = lists.get(list);
      const nodes = new Set([list, ...list.querySelectorAll(fields.map(([selector]) => selector).join(','))]);
      state.nodes.forEach(node => { if (!nodes.has(node)) state.observer.unobserve(node); });
      nodes.forEach(node => { if (!state.nodes.has(node)) state.observer.observe(node); });
      state.nodes = nodes;
      schedule(list);
    });
  };
  let refresh;
  const queueRefresh = () => {
    if (refresh) return;
    refresh = requestAnimationFrame(() => { refresh = null; initialize(); });
  };
  new MutationObserver(records => {
    if (records.some(record => (record.target.nodeType === 1 ? record.target : record.target.parentElement)?.closest(groupSelector) || [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches('.ProductCard') || node.querySelector('.ProductCard'))))) queueRefresh();
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
  initialize();
  document.fonts?.ready.then(() => lists.forEach((_, list) => schedule(list)));
  document.addEventListener('shopify:section:load', queueRefresh);
})();
